import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const SectionCard = ({ 
  title, 
  description, 
  icon, 
  isComplete, 
  onExpand,
  isExpanded,
  children 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden transition-smooth hover:shadow-card">
      <button
        onClick={onExpand}
        className="w-full p-6 flex items-center justify-between text-left hover:bg-muted/50 transition-smooth"
      >
        <div className="flex items-center gap-4 flex-1">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
            isComplete ? 'bg-success/10' : 'bg-primary/10'
          }`}>
            <Icon 
              name={icon} 
              size={24} 
              color={isComplete ? 'var(--color-success)' : 'var(--color-primary)'} 
            />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-lg font-semibold text-foreground">{title}</h3>
              {isComplete && (
                <div className="flex items-center gap-1 px-2 py-0.5 bg-success/10 rounded-full">
                  <Icon name="CheckCircle2" size={14} color="var(--color-success)" />
                  <span className="text-xs font-medium text-success">Complete</span>
                </div>
              )}
            </div>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          className="text-muted-foreground ml-4" 
        />
      </button>
      {isExpanded && (
        <div className="border-t border-border p-6 bg-muted/20">
          {children}
        </div>
      )}
    </div>
  );
};

export default SectionCard;